import { ConsumableAdstxtRecord } from '../domain/consumable-adstxt-record.model';

export class AdsTxtUtils {

  static getAdsTxtInTxtFormat(data: ConsumableAdstxtRecord[], withoutComment?: boolean, condensed = false) {
    let fileText = '';

    if (condensed) {
      data = data.filter(d => d.condensed);
    }

    data.forEach(unitData => {
      fileText = fileText + unitData.domain + ', ';
      fileText = fileText + unitData.publisherAccountId + ', ';
      fileText = fileText + unitData.accountType;
      if (unitData.certAuthority !== undefined) {
        fileText = fileText + ', ' + unitData.certAuthority;
      }
      if (unitData.comment !== undefined && withoutComment !== true) {
        fileText = fileText + ' #' + unitData.comment;
      }
      fileText += '\r\n';
    });
    return fileText;
  }
}
